// assets/default-in-stock.js
(function () {
  try {
    // Only affect collection pages (adjust if your URLs differ)
    if (!location.pathname.startsWith('/collections/')) return;

    const url = new URL(location.href);

    // If *any* filter is already present (including availability), do nothing.
    let hasAnyFilter = false;
    url.searchParams.forEach((v, k) => {
      if (k.startsWith('filter.')) hasAnyFilter = true;
    });
    if (hasAnyFilter) return;

    // First visit with no filters → add in-stock filter and reload
    url.searchParams.append('filter.v.availability', '1');
    location.replace(url.toString());
  } catch (e) {
    // Fail silently
  }
})();
